import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckIcon, DownloadIcon, ShieldCheckIcon } from 'lucide-react';
export function CTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const handlePurchase = () => {
    window.location.href = 'https://www.sinergianatural.com/cart/50923164827954:1';
  };
  return <section ref={ref} className="py-10 md:py-16 px-4 bg-gradient-to-b from-cream to-sage-light/20" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-3">
          <div className="text-center mb-8 md:mb-12 px-2" data-id="element-4">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-warm-brown mb-4 md:mb-6" data-id="element-5">
              No pases otro día sintiéndote menos de lo que puedes ser.
            </h2>
            <div className="prose prose-base md:prose-lg max-w-none text-gray-700 space-y-3 md:space-y-4" data-id="element-6">
              <p className="text-base md:text-lg" data-id="element-7">
                Durante años te dijeron que el cansancio, el dolor y la neblina
                mental eran normales para tu edad.
              </p>
              <p className="font-bold text-gray-900 text-lg md:text-xl" data-id="element-8">
                No lo son.
              </p>
              <p className="text-base md:text-lg" data-id="element-9">
                Son señales de que tu cuerpo está pidiendo las herramientas
                correctas.
              </p>
              <p className="text-lg md:text-xl font-semibold text-sage-dark" data-id="element-10">
                <strong data-id="element-11">Sinergia Ancestral</strong> te da exactamente eso.
              </p>
              <p className="text-base md:text-lg" data-id="element-12">
                Un sistema claro, probado y completamente accesible para
                recuperar tu energía, calmar tu dolor, dormir profundo y volver
                a sentirte el arquitecto de tu propia salud.
              </p>
              <div className="flex flex-col items-center gap-2 my-4 md:my-6 text-base md:text-lg" data-id="element-13">
                <p data-id="element-14">Todo con ingredientes que ya tienes.</p>
                <p data-id="element-15">Todo desde tu cocina.</p>
                <p className="font-bold text-terracotta" data-id="element-16">
                  Todo por menos de lo que cuesta un café.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-2xl p-6 md:p-12 border-2 md:border-4 border-terracotta" data-id="element-17">
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={handlePurchase} className="w-full bg-terracotta hover:bg-terracotta-dark text-white font-bold text-lg md:text-xl lg:text-2xl py-5 md:py-6 px-6 md:px-8 rounded-lg shadow-lg transition-all duration-200 mb-4 md:mb-6 cursor-pointer" aria-label="Obtener Sinergia Ancestral por $6.39" data-id="element-18">
              ✅ QUIERO RECUPERAR MI VITALIDAD POR $6.39
              <div className="text-sm md:text-base font-normal mt-2" data-id="element-19">
                OBTENER SINERGIA ANCESTRAL AHORA →
              </div>
            </motion.button>

            <div className="flex flex-col items-center gap-2 md:gap-3 text-xs md:text-sm text-gray-600 mb-3 md:mb-4" data-id="element-20">
              <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4" data-id="element-21">
                <span className="flex items-center gap-2" data-id="element-22">
                  <ShieldCheckIcon className="w-3 h-3 md:w-4 md:h-4" aria-hidden="true" data-id="element-23" />
                  Pago 100% seguro
                </span>
                <span data-id="element-24">•</span>
                <span className="flex items-center gap-2" data-id="element-25">
                  <DownloadIcon className="w-3 h-3 md:w-4 md:h-4" aria-hidden="true" data-id="element-26" />
                  Descarga inmediata
                </span>
                <span data-id="element-27">•</span>
                <span className="flex items-center gap-2" data-id="element-28">
                  <CheckIcon className="w-3 h-3 md:w-4 md:h-4" aria-hidden="true" data-id="element-29" />
                  Garantía de 60 días sin preguntas
                </span>
              </div>
            </div>

            <p className="text-center text-terracotta font-bold text-base md:text-lg" data-id="element-30">
              Precio de lanzamiento: $6.39 — Sube pronto de forma permanente
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}